import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormApiService } from '@app/core/services/form-api.service';
import { MeteringPointService } from '@app/api/dmc';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertService } from '@app/core/services/alert.service';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';

@Component({
  selector: 'app-stop-control-meter-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDateDirective
  ],
  templateUrl: './stop-control-meter-modal.component.html',
  styleUrl: './stop-control-meter-modal.component.css'
})
export class StopControlMeterModalComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    meterIdentification: new FormControl(null, Validators.required),
    validFrom: new FormControl(null, Validators.required),
  });

  public element?: any;
  public meteringPointIdentification?: string;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
    private readonly alertService: AlertService,
  ) {
  }

  public ngOnInit(): void {
    if (this.meteringPointIdentification && this.element) {
      if (!this.element.verificationMeter) {
        this.alertService.open('modal', 'danger', 'meteringPoint.controlMeter.stopControlMeter.wrongType')
        return;
      }
      this.form.get('meteringPointIdentification')?.setValue(this.meteringPointIdentification);
      this.form.get('meterIdentification')?.setValue(this.element.meterId);
    } else {
      this.alertService.open('modal', 'danger', 'meteringpoint.stopControlMeter.error')
    }
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.meteringPointService.meteringPointDisassociateVerificationMeterPost(data),
      {
        closeModal: true,
        successMessage: 'meteringpoint.meter.removecontrolmeter.success'
      }
    )
  }

}
